// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2Y1wC","disabled":"FileBtn_disabled__2oHj8","warn":"FileBtn_warn__45EtR","fade":"FileBtn_fade__DprJi"};